import { Accordion, Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { evisActionTypes } from '../../contexts/evis/evisActionTypes';
import { GlobalContext } from '../../contexts/globalContextStore/GlobalContextStore';
import { FavoriteSession } from '../../pages/favoritesession/FavoriteSession';
import { FloatingNotesIcon } from '../../pages/notes/FloatingNotesIcon';
import { Questions } from '../../pages/questions/Questions';
import { Snapshot } from '../../pages/shareicon/Snapshot';
import { StyledAccordionSummary } from "../CustomComponents";

export const Footer = () => {
    const { storeState, storeDispatch } = useContext(GlobalContext);
    const { evisStates } = storeState;
    const { evisSortMode } = evisStates;

    const toggleSortMode = () => {
        storeDispatch({
            type: evisActionTypes.EVIS_SET_SORT_MODE,
            evisSortMode: evisSortMode === "type" ? "interleaved" : "type",
        });
    };

    return (
        <React.Fragment>
            <Box sx={{ marginTop: "auto" }} component="footer">
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 1, gap: 1 }}>
                    <Typography variant="caption" sx={{ color: "#a89587" }}>
                        Sort streams by:
                    </Typography>
                    <Select
                        value={evisSortMode}
                        onChange={(e) => storeDispatch({ type: evisActionTypes.EVIS_SET_SORT_MODE, evisSortMode: e.target.value })}
                        size="small"
                        sx={{ color: "#d18410", fontSize: "0.75rem", '.MuiOutlinedInput-notchedOutline': { borderColor: "#d18410" }, '.MuiSvgIcon-root': { color: "#d18410" }}}
                    >
                    <MenuItem value="type" sx={{ fontSize: "0.75rem" }}>Prim-Secd</MenuItem>
                    <MenuItem value="interleaved" sx={{ fontSize: "0.75rem" }}>By Region</MenuItem>
                    </Select>
                </Box>
                <Accordion expanded={true}>
                    <StyledAccordionSummary
                        aria-controls="footer"
                        id={"footer"}
                        sx={{
                            flexGrow: 1,
                            textAlign: "center",
                            fontWeight: "bold",
                        }}
                    >
                        <Stack spacing={2}>
                            <Stack direction="row" spacing={4}>
                                <div><Questions /></div>
                                <div><FloatingNotesIcon /></div>
                                <div><FavoriteSession /></div>
                                <div><Snapshot /></div>
                            </Stack>
                            <div>
                                <Typography variant="subtitle1" sx={{
                                    display: "inline-block",
                                    pointerEvents: "none !important",
                                    cursor: "none !important",
                                }}>
                                    Developed by: <i>{"PV-Live-Infra"}</i>
                                </Typography>
                            </div>
                        </Stack>
                    </StyledAccordionSummary>
                </Accordion>
            </Box>
        </React.Fragment>
    );
};